<template>
    <div>
        <vs-button  color="danger" type="filled" small @click="pushNotification=true">New Notify</vs-button> <br>
         <vs-prompt @cancel="val=''" blur @accept="pushNotify" @close="pushNotification=false" :active.sync="pushNotification"
            accept-text="Add" title="Push Notification">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Title"  v-model="notify.title" />
                <vs-textarea placeholder="Body" v-model="notify.body" />
            </div>
        </vs-prompt>
        <vs-table :data="notifications">
            <template slot="header">
                <h3>
                    Title
                </h3>
            </template>
            <template slot="thead">
                <vs-th>
                    Contents
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].headings.ar">
                        {{data[indextr].headings.ar}}
                    </vs-td>
                    <vs-td :data="data[indextr].contents.ar">
                        {{data[indextr].contents.ar}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                 notifications: [],
                 pushNotification: false,
                 notify:{
                     title:'',
                     body:''
                 }
            }
        },
        methods: {
            fetchNotifications() {
                this.axios.get(`${this.$apiUrl}/v2/notifications`).then(res => {
                    this.notifications = res.data
                })
            },
             pushNotify() {
                this.$vs.loading()
                this.axios.post(`${this.$apiUrl}/notify/custom`,{
                    'type':'custom',
                    'data':this.selected,
                    'options':this.notify
                }).then(res => {
                    this.$vs.loading.close()
                     if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Notification Push',
                            text: ''
                        })
                    }
                }).catch(err=>{
                    this.$vs.loading.close()
                })
            },
        },
        created() {
            this.fetchNotifications();
        },
    }
</script>